// Before & after CDN project images
export const BEFORE_AFTER_1 =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab28837ff484614db9d2019.webp";
export const BEFORE_AFTER_2 =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab288372c80cdf1d5a6745f.webp";
